import React from 'react';

export interface IRadioButtonProps {
  fillColor?: string;
  strokeColor?: string;
  internalRadius?: string;
}

const RadioButtonIcon:React.FC<IRadioButtonProps> = (props) => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9.5" cy="9.5" r="8.75" stroke={props.strokeColor ?? "#4F506D"} stroke-width="1.5"/>
      <circle cx="9.5" cy="9.5" r={props.internalRadius ?? "5.5"} fill={props.fillColor ?? "#4F506D"}/>
    </svg>
  )
}

export default RadioButtonIcon;